<template>
  <div id="wrapper">
    <Nav :message="message" />
    <Mind :users="users" />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import Mind from '@/components/tools/Mind.vue'

export default {
  name: 'name-card',
  props: ['message', 'users'],
  components: {
    Nav,
    Mind
  }
}
</script>